var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('inquiries',{attrs:{"url":'/my-travel/inquries',"hide-alerts":true}})}
var staticRenderFns = []

export { render, staticRenderFns }